module.exports = __webpack_public_path__ + "img/pic_3_tc.28c5ba84.png";